import { useCallback, useState } from 'react';

// MUI closes a Snackbar with this reason when the user clicks outside it. The
// alert stays open in that case: it is dismissed only by the close button or
// by its own timeout, so a stray click does not hide an error the user has
// not read yet.
const CLICKAWAY_REASON = 'clickaway';

const EMPTY_ALERT = {
    severity: 'info',
    title: '',
    description: '',
    className: '',
};

function useAlert () {
    const [isOpen, setIsOpen] = useState(false);
    const [alert, setAlert] = useState(EMPTY_ALERT);

    const showAlert = useCallback((next) => {
        setAlert({ ...EMPTY_ALERT, ...next });
        setIsOpen(true);
    }, []);

    const closeAlert = useCallback((_, reason) => {
        if (reason === CLICKAWAY_REASON) return;
        setIsOpen(false);
        setAlert(EMPTY_ALERT);
    }, []);

    return { isOpen, alert, showAlert, closeAlert };
}

export default useAlert;
